// Constants — extrahiert aus app/src/components/editor/Viewer/viewerConstants.ts
// (Plan A Mapping-Audit 2026-05-22).
//
// `SIZES` enthält Editor-spezifische Layout-Constants. Im public/-Konsum
// werden nur wenige davon verwendet (z.B. defaultPageMaxWidth). Gesamtes
// Objekt exportiert zur Vermeidung von Drift.

export const SIZES = {
  timeSelectorHeight: 10,
  timelineHeight: 60,
  timelineControlWidth: 200,
  slideHeight: 30,
  memorydotsHeight: 20,
  menuHeight: 0,
  layerHeight: 20,
  groupIndentation: 5,

  landingHeroMaxHeight: 1200,
  landingHeroTextMaxWidth: 600,
  gridMaxWidth: 1000,
  gridMaxWidthTabletPortait: 680,
  gridPadding: 20,
  gridGap: 40,
  landingMainContentOffset: 40,

  storyHeroTitleMaxWidth: 680,
  storyHeroStartButtonWidth: 80,

  defaultPageMaxWidth: 670,
  defaultPagePaddingTop: 240,

  avatarSmall: 120,
  avatarLarge: 160,

  cardsYAxisPadding: 25,
  cardXAxisPadding: 20,

  badgeAndTagOffset: 2,

  editorSidebarWidth: 370,
  layerControlsWidth: 75,
  keyframeDot: 10,

  narrowEnoughForFullScreenInEmbedMode: 1024,
};

export const VIEWER_MOBILE_BREAKPOINT = 768;
export const TEXT_SHADOW = "5px 5px 10px rgba(000, 000, 000, 0.4)";

export const IS_HTML_MODE = typeof document === "undefined";

export const VIEWER_ROOT_CONTAINER = "viewer-root-container";
